import { post } from "./utils";

export const postCourseEnrollment = async (externalId: string) =>
  await post("courses/enrollment", { externalCourseId: externalId });
